WAU.RecentlyViewed = (function () {

  var STORAGE_VERSION = 'v1';
  var MAX_STORED = 10;
  var MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000;

  function storageKey() {
    var shopName = (window.Shopify && Shopify.shop) ? Shopify.shop.split('.')[0] : 'shop';
    return shopName + '.products.recent_products.' + STORAGE_VERSION;
  }

  function readStored() {
    try {
      var raw = window.localStorage.getItem(storageKey());
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function writeStored(list) {
    try {
      window.localStorage.setItem(storageKey(), JSON.stringify(list));
    } catch (e) {}
  }

  function dropExpired(list) {
    var cutoff = Date.now() - MAX_AGE_MS;
    return list.filter(function (item) {
      return item && item.viewed_at && item.viewed_at > cutoff && item.grid_item;
    });
  }

  function loadCarouselIfNeeded(container, carouselAssetUrl) {
    if ( !container.querySelector('.js-carousel') ) return;

    if (typeof carouselInit === 'function') {
      setTimeout(function () { carouselInit(container); }, 200);
      return;
    }

    if ( !carouselAssetUrl ) return;

    var loader = new WAU.Helpers.scriptLoader();
    loader.load([carouselAssetUrl]).finally(function () {
      setTimeout(function () { carouselInit(container); }, 200);
    });
  }

  function renderCards(container, items) {
    var target = container.querySelector('.js-recently-viewed-grid') || container.querySelector('.js-recently-viewed-loop');
    if ( !target ) return;

    items.forEach(function (item) {
      target.insertAdjacentHTML('beforeend', item.grid_item);
    });

    container.removeAttribute('hidden');

    if (WAU.Quickshop) WAU.Quickshop.init();
    if (WAU.ProductGridVideo) WAU.ProductGridVideo.init();
    WAU.Helpers.lazyLoad('.lazy', true);
  }

  function init(container) {
    var currentId = container.dataset.productId,
        currentHandle = container.dataset.productHandle,
        currentGridItem = container.dataset.gridItem,
        howManyToShow = parseInt(container.dataset.howManyToShow, 10) || 4,
        carouselAssetUrl = container.dataset.carouselAssetUrl;

    if ( !currentGridItem ) return;

    var others = dropExpired(readStored()).filter(function (item) {
      return item.id !== currentId;
    });

    if (others.length > 0) {
      renderCards(container, others.slice(0, howManyToShow));
      loadCarouselIfNeeded(container, carouselAssetUrl);
    }

    others.unshift({
      id: currentId,
      handle: currentHandle,
      grid_item: currentGridItem,
      viewed_at: Date.now()
    });

    writeStored(others.slice(0, MAX_STORED));
  }

  return { init: init };

})();

document.querySelectorAll('[data-section-type="recently-viewed"]').forEach(function (container) {
  WAU.RecentlyViewed.init(container);
});

document.addEventListener('shopify:section:load', function (event) {
  var container = event.target.querySelector('[data-section-type="recently-viewed"]');
  if ( !container ) return;
  WAU.RecentlyViewed.init(container);
});
